import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import { runSchema } from './model.js';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'ads.simulation.published': {
    schema: runSchema,
    journal: { label: fr.event, importance: 'normal' },
    realtime: true,
  },
  'ads.changed': {
    schema: z.object({ id: z.uuid(), kind: z.enum(['campaign', 'run', 'report']) }),
    journal: { label: fr.changedEvent, importance: 'normal' },
    realtime: true,
  },
});
